import * as React from 'react';
import { Text, View ,StyleSheet, TextInput ,TouchableOpacity} from 'react-native';
import { MaterialCommunityIcons } from '@expo/vector-icons';
import Checkbox from 'expo-checkbox';
import Swal from 'sweetalert2'

export default function cadastro({navigation}) {
  const [isChecked, setChecked] =  React.useState(false);
  const [nome, setText] = React.useState('');
  const [senha,setSenha] = React.useState('');
  const [Csenha,setCSenha] = React.useState('');
  const [user,setUser] = React.useState('');

  //cont register


  const register=(nome,senha,user)=>{

    var validatinoApi ='https://wesleymontaigne.com/checkout/controller/api/createuser.php';
    var headers={
     'Accept':'application/json',
     'Content-Type':'application.json',
     'Access-Control-Allow-Methods': 'GET, POST, PUT, DELETE, OPTIONS',
     'Access-Control-Allow-Origin':'*',
     'crossDomain': 'true',
     'Host': 'https://wesleymontaigne.com/checkout/controller/api/createuser.php',
     'Origin': 'https://wesleymontaigne.com',
     'credentials': 'same-origin',
     'Access-Control-Allow-Credentials': 'true'
     
      };
     /*'crossDomain': 'true',*/
     var Data={
      nome:nome,
      senha:senha,
      user:user
       };
  
      fetch(validatinoApi,
      {
      method:'POST',
      headers:headers,
      body:JSON.stringify(Data)
      }).then((response)=>response.json())
      .then((response)=>{
      if(response.statusCode==200){
      navigation.navigate('validationsms',{id:nome})
       }else{
        Swal.fire({
          icon: 'error',
          title: 'Algo errado...',
          text: 'Confira todos os dados os não pode haver dois cadastro com o mesmo numero de telefone',
          })
      } 
      }).catch((error)=>{
      alert(error);
      });
      
    }
  
  

  


  return (
<View style={{ flex: 1, alignItems: 'center' ,backgroundColor:'#01150E' }}>
<MaterialCommunityIcons name="food-fork-drink" size={80} color="white" />
      <TextInput
       onChangeText={(nome) => setText(nome)}
       style={{height: 80,
        margin: 12,
        borderWidth: 1,
        borderBottomWidth: 1,
        borderLeftWidth: 0,
        borderRightWidth:0,
        borderTopWidth: 0,
        borderColor:'white',
        outline: 'none',
        color:'white',
        placeholderTextColor:'white'}}
        onClick={()=>{         
         
        }}
        placeholder="Telefone"
        keyboardType='numeric'
        
      />


<TextInput
       onChangeText={(user) => setUser(user)}
       style={{height: 80,
        margin: 12,
        borderWidth: 1,
        borderBottomWidth: 1,
        borderLeftWidth: 0,
        borderRightWidth:0,
        borderTopWidth: 0,
        borderColor:'white',
        outline: 'none',
        color:'white',
        placeholderTextColor:'white'}}
        onClick={()=>{         
         
        }}
        placeholder="Primeiro Nome"
        keyboardType='text'
        
      />



      <TextInput
        onChangeText={(senha) => setSenha(senha)}
        style={{height: 40,
        margin: 12,
        borderWidth: 1,
        borderBottomWidth: 1,
        borderLeftWidth: 0,
        borderRightWidth:0,
        borderTopWidth: 0,
        borderColor:'white',
        outline: 'none',
        color:'white',
        placeholderTextColor:'white'}}
        onClick={()=>{/**/ }}
        placeholder="Senha"
        secureTextEntry={true}
      />

<TextInput
onChangeText={(Csenha) => setCSenha(Csenha)}
        style={{height: 40,
          margin: 12,
          borderWidth: 1,
          borderBottomWidth: 1,
          borderLeftWidth: 0,
          borderRightWidth:0,
          borderTopWidth: 0,
          borderColor:'white',
          outline: 'none',
          color:'white',
          placeholderTextColor:'white'}}
        onClick={()=>{/**/  }}
        placeholder="Confirmar Senha"
        secureTextEntry={true}
      />

      <TouchableOpacity onPress = {() => {/* do this */
      if(isChecked){
  
      if(nome.length==11&&user!=''){
       

        if(senha<5){
         
          Swal.fire({
            icon: 'error',
            title: '',
            text: 'Senha muito curta!',
            })       

        }else{
        
          if(senha!=Csenha){
            Swal.fire({
              position: 'top',
              icon: 'error',
              title: 'Senhas não são iguais',
              showConfirmButton: false,
              timer: 2000
            })
          }else{
          //insert
          register(nome,senha,user);

          } 
          
        }

        }else{

          Swal.fire({
            icon: 'error',
            title: 'Coloque o DDD',
            text: 'Use apenas numeros!',
            
          })

        }//end check validation
        
        

      }else{

        Swal.fire({
          icon: 'error',
          title: '',
          text: 'Concorde com os termos de uso!',
          footer: '<a href=https://www.apple.com/privacy/>Ler termos?</a>'
        })
      }
      }}>
    <View style = {{backgroundColor: 'white', alignItems: 'center', 
                    justifyContent: 'center' ,borderRadius: 10,width:110 }}
           >
        <Text style = {{ color: '#01150E', padding:10}}>Entrar</Text>
    </View>
</TouchableOpacity>

<View style={{margin:20,alignItems:'center'}}>
  <Text style={{color:'white'}}>Aceitar</Text>
<Checkbox style={styles.checkbox} value={isChecked} onValueChange={setChecked} />
<a href='https://www.apple.com/privacy/'><Text style={styles.paragraph}>Ler Politica de privacidade</Text></a>

</View>
</View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    marginHorizontal: 16,
    marginVertical: 32,
  },
  section: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  paragraph: {
    fontSize: 15,
    color:'white'
   
  },
  checkbox: {
    margin: 8,
  },
});